import "./style.css";
import React from "react";
import { stateToHTML } from "draft-js-export-html";
import "../../../node_modules/draft-js/dist/Draft.css";
import {
  Editor,
  EditorState,
  getDefaultKeyBinding,
  RichUtils,
  ContentState,
  convertFromHTML,
  ContentBlock,
  Modifier,
} from "draft-js";
// import parse from "html-react-parser";

class RichTextEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
    };

    this.onChange = (editorState) => {
      this.setState({ editorState });
    };
    this.handlePastedText = this.handlePastedText.bind(this);
    let overview = props?.userDetails?.description
      ? props?.userDetails?.description
      : props?.userDetails
      ? props?.userDetails
      : "<p></p>";

    if (props?.userDetails?.description === null) {
      overview = "<p></p>";
      overview = props?.userDetails?.description;
    } else if (props.userDetails && !props.userDetails?.description) {
      overview = props?.userDetails ? props.userDetails : "<p></p>";
    } else if (props.userDetails?.description) {
      overview = props.userDetails?.description;
    } else {
      overview = "<p></p>";
    }

    const contentDataState = ContentState.createFromBlockArray(
      props.over
        ? convertFromHTML(
            overview?.description ? overview?.description : "<p></p>"
          )
        : convertFromHTML(overview ? overview : "<p></p>")
      // Ensure overview is not empty
    );

    const editorDataState = EditorState.createWithContent(contentDataState);

    this.state = {
      editorState: editorDataState,
    };

    this.focus = () => this.refs.editor.focus();
    this.onChange = (editorState) => {
      this.setState({ editorState });
      const contentState = editorState.getCurrentContent();
      const html = stateToHTML(contentState);
      const trimmedHTML = typeof html === "string" ? html.trim() : String(html);

      props.setUserDetails({
        ...props.userDetails,
        description: trimmedHTML || "<p></p>", // Provide a default value if trimmedHTML is falsy
      });
    };
    this.handleKeyCommand = this._handleKeyCommand.bind(this);
    this.mapKeyToEditorCommand = this._mapKeyToEditorCommand.bind(this);
    this.toggleBlockType = this._toggleBlockType.bind(this);
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this);
  }

  onEditorStateChange = (editorStateData) => {
    this.setState({ editorState: editorStateData });
  };
  _handleKeyCommand(command, editorState) {
    if (command === "split-block") {
      // Insert a new paragraph block when Enter key is pressed
      this.onChange(RichUtils.insertSoftNewline(editorState));
      return true;
    }
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }
  _mapKeyToEditorCommand(e) {
    if (e.keyCode === 9) {
      const newEditorState = RichUtils.onTab(
        e,
        this.state.editorState,
        4 /* maxDepth */
      );
      if (newEditorState !== this.state.editorState) {
        this.onChange(newEditorState);
      }
      return;
    }
    return getDefaultKeyBinding(e);
  }

  _toggleBlockType(blockType) {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType));
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle)
    );
  }

  // normal ashxatox aranc smilikneri
  onPaste() {
    setTimeout(() => {
      const editorState = this.state.editorState;
      const currentContent = editorState.getCurrentContent();
      const selectionState = editorState.getSelection();

      if (!selectionState.isCollapsed()) {
        const newSelectionState = selectionState.merge({
          anchorOffset: selectionState.getStartOffset(),
          focusOffset: selectionState.getStartOffset(),
        });
        this.onChange(
          EditorState.forceSelection(editorState, newSelectionState)
        );
      }

      const contentState = this.state.editorState.getCurrentContent();
      const blocks = contentState.getBlockMap();
      let pastedText = "";

      blocks.forEach((block) => {
        pastedText += block.getText() + "\n";
      });
    }, 0);
  }

  // porcum enq

  handlePastedText(text, html, editorState) {
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();

    // Заменим текстовые смайлики на Unicode символы смайликов
    const withSmilies = text
      .replace(/:\)/g, "😊") // 🙂
      .replace(/:\(/g, "😞") // :(
      .replace(/;\)/g, "😉"); // ;)

    // Вставим обновленный текст в редактор
    const newContentState = Modifier.replaceText(
      contentState,
      selectionState,
      withSmilies
    );

    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      "insert-characters"
    );
    this.onChange(newEditorState);

    // Возвращаем true, чтобы предотвратить стандартное поведение редактора
    return true;
  }

  // onPaste(e) {
  //   if (e && e.preventDefault) {
  //     e.preventDefault(); // Предотвращаем стандартное выполнение вставки
  //   } else {
  //     // Для старых версий IE
  //     window.event.returnValue = false;
  //   }

  //   // Получаем вставленные данные из буфера обмена
  //   const pastedData = (e.clipboardData || window.clipboardData)?.getData(
  //     "text"
  //   );

  //   // Проверяем, были ли вставлены данные
  //   if (!pastedData) return;

  //   // Создаем новое содержимое на основе вставленных данных
  //   const editorState = this.state.editorState;
  //   const contentState = editorState.getCurrentContent();
  //   const selectionState = editorState.getSelection();
  //   const newContentState = Modifier.replaceText(
  //     contentState,
  //     selectionState,
  //     pastedData
  //   );
  //   const newEditorState = EditorState.push(
  //     editorState,
  //     newContentState,
  //     "insert-characters"
  //   );
  //   this.onChange(newEditorState);
  // }

  render() {
    const { editorState } = this.state;

    let className = "RichEditor-editor";
    var contentState = editorState.getCurrentContent();
    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== "unstyled") {
        className += " RichEditor-hidePlaceholder";
      }
    }

    return (
      <div className="RichEditor-root">
        <BlockStyleControls
          editorState={editorState}
          onToggle={this.toggleBlockType}
        />
        <InlineStyleControls
          editorState={editorState}
          onToggle={this.toggleInlineStyle}
        />
        <div className={className} onClick={this.focus}>
          <Editor
            readOnly={this.props.disable}
            blockStyleFn={getBlockStyle}
            customStyleMap={styleMap}
            editorState={editorState}
            onEditorStateChange={this.onEditorStateChange}
            handleKeyCommand={this.handleKeyCommand}
            keyBindingFn={this.mapKeyToEditorCommand}
            onChange={this.onChange}
            placeholder="Доп. информация"
            ref="editor"
            spellCheck={true}
            // handlePastedText={this.handlePastedText}
            onPaste={this.onPaste}
          />
        </div>
      </div>
    );
  }
}

// Custom overrides for "code" style.
const styleMap = {
  CODE: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};

function getBlockStyle(block) {
  switch (block.getType()) {
    case "blockquote":
      return "RichEditor-blockquote";
    default:
      return null;
  }
}

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = "RichEditor-styleButton";
    if (this.props.active) {
      className += " RichEditor-activeButton";
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

const BLOCK_TYPES = [
  // { label: 'H1', style: 'header-one' },
  // { label: 'H2', style: 'header-two' },
  // { label: 'H3', style: 'header-three' },
  // { label: 'H4', style: 'header-four' },
  // { label: 'H5', style: 'header-five' },
  // { label: 'H6', style: 'header-six' },
  // { label: 'Blockquote', style: 'blockquote' },
  // { label: 'UL', style: 'unordered-list-item' },
  // { label: 'OL', style: 'ordered-list-item' },
  // { label: 'Code Block', style: 'code-block' },
];

const BlockStyleControls = (props) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

var INLINE_STYLES = [
  { label: "Жирный", style: "BOLD" },
  { label: "Курсив", style: "ITALIC" },
  { label: "Подчёркнутый", style: "UNDERLINE" },
  // { label: 'Monospace', style: 'CODE' },
];

const InlineStyleControls = (props) => {
  const currentStyle = props.editorState.getCurrentInlineStyle();

  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

export default RichTextEditor;
